import { render, staticRenderFns } from "./tda_sources.vue?vue&type=template&id=bb684924&scoped=true&"
import script from "./tda_sources.vue?vue&type=script&lang=js&"
export * from "./tda_sources.vue?vue&type=script&lang=js&"
import style0 from "./tda_sources.vue?vue&type=style&index=0&id=bb684924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb684924",
  null
  
)

export default component.exports